import type {
  ClipboardPayloadEntry,
  ClipboardSelection,
  TimeGridEntity,
  TimeGridEvent,
} from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'

export type ClipboardScopeKind = 'row' | 'column' | 'cells' | 'events'

export interface ClipboardData {
  source: ClipboardSelection<TimeGridEntity, TimeGridEvent>
  payload: ClipboardPayloadEntry[]
  mode: 'copy' | 'move'
  scopeKind: ClipboardScopeKind
  selectionSnapshot: string
}

export interface ClipboardState {
  clipboard: ClipboardData | null
}

export type ClipboardDispatch = (arg0: ClipboardAction) => void

export type ClipboardAction =
  | {
      type: 'SET_CLIPBOARD'
      clipboard: ClipboardData
    }
  | {
      type: 'CLEAR_CLIPBOARD'
    }

export function initialClipboardState(): ClipboardState {
  return {
    clipboard: null,
  }
}

export default function reducer(state: ClipboardState, action: ClipboardAction): ClipboardState {
  switch (action.type) {
    case 'SET_CLIPBOARD':
      return { ...state, clipboard: action.clipboard }
    case 'CLEAR_CLIPBOARD':
      return { ...state, clipboard: null }
    default:
      return state
  }
}
